module.exports = __webpack_public_path__ + "media/images/landing__bg--phone-6db1703ad59b93c269bb7d7a8e4a2d85.jpg";